import Modules from '@/classes/modules/Modules'

export default class Column {
  constructor ({ blocks } = {}) {
    this.blocks = new Modules(blocks)
  }
}
